'use strict';

module.exports = require('./is-implemented')()
	? String.prototype.contains
	: require('./shim');



//////////////////
// WEBPACK FOOTER
// ./node_modules/es5-ext/string/#/contains/index.js
// module id = 1337
// module chunks = 1